import { Link } from "react-router-dom";

export const Logo = ({ className = "text-2xl", to = "/" }) => (
  <Link to={to} data-testid="logo" aria-label="ROXPAIR — Accueil" className={`font-display uppercase tracking-wide leading-none ${className}`}>
    RO<span className="text-rox-orange">X</span>PAIR
  </Link>
);
